<template>
    <div class="info-div">
        <el-link type="primary" class="info-link" @click="showInfo">详情</el-link>
        <el-dialog :visible.sync="showInfoDialog" :title="sellerName + ' ' + date + ' 业绩详情' ">
            <el-radio-group v-model="radio" class="info-radio">
                <el-radio label="order">当月成交数据</el-radio>
                <el-radio label="bill">当月实收数据</el-radio>
            </el-radio-group>

            <el-table
                :data="orderRecords"
                stripe
                height="600"
                v-show="radio == 'order'"
                :summary-method="getSummaries"
                show-summary
            >
                <el-table-column prop="shopName" label="所属店铺" width="100"></el-table-column>
                <el-table-column prop="buyerInfo" label="客户名称" width="200"></el-table-column>

                <el-table-column prop="id" label="订单号" width="200">
                    <template slot-scope="order">
                        {{order.row.id}}
                        <el-tag type="danger" v-if="order.row.tags.indexOf('sample_order') != -1">样</el-tag>
                        <el-tag type="ssuccess" v-if="order.row.isShippingFee == 'Y'">运</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="订单状态" width="150"></el-table-column>

                <el-table-column prop="totalAmount" label="订单金额($)" width="100">
                    <template slot-scope="order">{{ $tools.parsecost(order.row.totalAmount, true)}}</template>
                </el-table-column>

                <el-table-column prop="shippingFeeAmount" label="运费($)" width="100">
                    <template
                        slot-scope="order"
                    >{{ $tools.parsecost(order.row.shippingFeeAmount, true)}}</template>
                </el-table-column>

                <el-table-column prop="createDate" label="下单时间" width="160">
                    <template slot-scope="order">{{ $tools.timestampToTime(order.row.createDate)}}</template>
                </el-table-column>
            </el-table>

            <el-table
                :data="billRecords"
                stripe
                height="600"
                v-show="radio == 'bill'"
                :summary-method="getSummaries"
                show-summary
                :span-method="objectSpanMethod"
            >
                <el-table-column prop="shopName" label="所属店铺" width="100"></el-table-column>
                <el-table-column prop="buyerInfo" label="客户名称" width="200"></el-table-column>

                <el-table-column prop="id" label="订单号" width="200">
                    <template slot-scope="order">
                        {{order.row.id}}
                        <el-tag type="danger" v-if="order.row.tags.indexOf('sample_order') != -1">样</el-tag>
                        <el-tag type="success" v-if="order.row.isShippingFee == 'Y'">运</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="订单状态" width="150"></el-table-column>

                <el-table-column prop="totalAmount" label="订单金额($)" width="100">
                    <template slot-scope="order">{{ $tools.parsecost(order.row.totalAmount, true)}}</template>
                </el-table-column>

                <el-table-column prop="shippingFeeAmount" label="运费($)" width="100">
                    <template
                        slot-scope="order"
                    >{{ $tools.parsecost(order.row.shippingFeeAmount, true)}}</template>
                </el-table-column>

                <el-table-column prop="createDate" label="下单时间" width="160">
                    <template slot-scope="order">{{ $tools.timestampToTime(order.row.createDate)}}</template>
                </el-table-column>

                <el-table-column prop="amount" label="实收金额($)" width="150" fixed="right">
                    <template slot-scope="order">
                        <span v-if="order.row.amount >= 0">
                            {{ order.row.isDone == 'Y' ? $tools.parsecost(order.row.amount - order.row.shippingFeeAmount, true) : $tools.parsecost(order.row.amount, true)}}
                            <el-tag type="warning" v-if="order.row.isDone == 'Y'">齐</el-tag>
                            <el-tag type="info" v-if="order.row.isDone == 'Y' && order.row.shippingFeeAmount">运</el-tag>
                        </span>
                        <span v-else>
                            {{$tools.parsecost(order.row.amount + order.row.shippingFeeAmount, true)}}
                            <el-tag type="danger">退</el-tag>
                        </span>
                    </template>
                </el-table-column>

                <el-table-column prop="bizDate" label="收款时间" width="160" fixed="right">
                    <template slot-scope="order">{{ $tools.timestampToTime(order.row.bizDate)}}</template>
                </el-table-column>
            </el-table>

            <div slot="footer" class="dialog-footer" :v-if="false">
                <el-button type="primary" size="small" class="op-button">导出</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        seller: { type: Number, default: null },
        sellerName: { type: String, default: null },
        date: { type: String, default: null },
        status: { type: String, default: null },
        isRoot: { type: Boolean, default: false },
    },
    data() {
        return {
            radio: "order",
            params: {},
            orderRecords: [],
            billRecords: [],
            showInfoDialog: false,
        };
    },
    methods: {
        showInfo() {
            let _this = this;

            _this.params = {
                seller: _this.seller,
                reportDate: _this.date,
                status: _this.status,
            };

            _this.$http.post(
                [
                    _this.isRoot
                        ? "alibaba/order/reportInfo"
                        : "alibaba/order/myreportInfo",
                    _this.params,
                ],
                [
                    function (data) {
                        _this.showInfoDialog = true;
                        _this.orderRecords = data.order;
                        _this.billRecords = data.bill;
                    },
                ],
                ".info-div"
            );
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            let _this = this;

            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = "总价";
                } else if (
                    column.property == "totalAmount" ||
                    column.property == "shippingFeeAmount"
                ) {
                    let total = 0;
                    const values = data.map(
                        (item) => (total += Number(item[column.property]))
                    );
                    sums[index] = _this.$tools.parsecost(total, true);
                } else if (column.property == "amount") {
                    let total = 0;
                    const values = data.map((item) => {
                        total += Number(item[column.property]);

                        if (item.isDone == "Y") {
                            if (item.amount >= 0) {
                                total -= Number(item.shippingFeeAmount);
                            } else {
                                total += Number(item.shippingFeeAmount);
                            }
                            
                        }
                    });
                    sums[index] = _this.$tools.parsecost(total, true);
                } else {
                    sums[index] = "";
                }
            });
            return sums;
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (column.property != "amount" && column.property != "bizDate") {
                if (row.rowspan > 1) {
                    return [row.rowspan, 1];
                } else if (row.rowspan == -1) {
                    return [1, 1];
                } else {
                    return [0, 1];
                }
            } else {
                return [1, 1];
            }
        },
        exportInfo() {},
    },
};
</script>

<style lang="scss" scoped>
.info-div {
    float: right;
}
.info-radio {
    width: 100%;
    text-align: center;
}
</style>